module.exports = __webpack_public_path__ + "static/assets/47aef1d83301e37025553b8b6982e3dd.png";